export default __webpack_public_path__ + "static/visa-ce7b0f76d679fcc5bb0d3933e86ad282.svg";